import { groupEvidenceProfiles } from '@/components/deals/evidence/evidence-presentation'

export function MarketEvidencePendingProfiles({
  hiddenProfileKeys,
  profileIds,
  profileLabels,
  profiles,
  status = 'refreshing',
}) {
  const refreshing = status === 'refreshing'

  return groupEvidenceProfiles(
    profileIds ?? [],
    profileLabels,
    profiles,
    hiddenProfileKeys,
  ).map((group) => {
    return (
      <section
        key={`${status}:${group.profileKey}`}
        aria-label={group.profileLabel}
        className="rounded-lg border border-border bg-muted/30 p-4"
      >
        <h4 className="font-bold text-foreground">{group.profileLabel}</h4>
        <p
          role={refreshing ? 'status' : undefined}
          className="mt-1 text-sm text-muted-foreground"
        >
          {refreshing ? 'Refreshing evidence…' : 'Evidence unavailable.'}
        </p>
      </section>
    )
  })
}
